import { Box, Typography } from '@mui/material';
import { AttributeText } from 'src/graphql/entities/custom-attributes/field-view-registry/components/attribute-text';
import { EmptyValue } from 'src/graphql/entities/custom-attributes/field-view-registry/components/empty-value';
import { CustomAttributeReadProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';

export type TextKind = 'short_text' | 'multi_line_text';

export const ShortTextView = ({ value }: CustomAttributeReadProps) => {
  const textValue = getKindLikeValueSafely(value, 'short_text');

  if (!textValue) {
    return <EmptyValue />;
  }

  return <AttributeText sx={{ whiteSpace: 'pre-wrap' }}>{textValue}</AttributeText>;
};

ShortTextView.displayName = 'short_text-view';

export const MultiLineTextView = ({ value }: CustomAttributeReadProps) => {
  const textValue = getKindLikeValueSafely(value, 'multi_line_text');

  if (!textValue) {
    return (
      <Box
        sx={{
          borderRadius: 1,
          backgroundColor: 'action.hover',
          px: 1,
          py: 0.75,
        }}
      >
        <EmptyValue />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        borderRadius: 1,
        backgroundColor: 'action.hover',
        px: 1,
        py: 0.75,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: '0.8rem',
          whiteSpace: 'pre-wrap',
          overflowWrap: 'anywhere',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        {textValue}
      </Typography>
    </Box>
  );
};

MultiLineTextView.displayName = 'multi_line_text-view';
